module.exports = __webpack_public_path__ + "img/77.9cb8be73.jpg";